import { Property } from '../../../../properties/property'
import { ConstraintOperator } from '../../../../process/capability-spec/constraints/constraint-operator'
import { ConstraintInput } from './constraintInput'

export interface Constraint {
  readonly property: Property
  readonly operator: ConstraintOperator
  readonly values: string[]
  readonly matchIfMissingProp: boolean
  readonly inputRequired: boolean
}

export const toQueryParam: (constraint: Constraint) => string = (constraint: Constraint) =>
  constraint?.property?.id +
  ':' +
  constraint?.operator +
  ':' +
  toQueryParams(constraint?.values) +
  ':' +
  (constraint?.matchIfMissingProp ? 'matchIfMissing' : '')

const toQueryParams: (values: string[]) => string = (values: string[]) => {
  if (values?.length > 0) {
    return values.join('!')
  } else {
    return ''
  }
}

export const buildConstraint: (constraintInput: ConstraintInput) => Constraint = (
  constraintInput: ConstraintInput
) =>
  <Constraint>{
    property: constraintInput.spec.property,
    operator: constraintInput.spec.operator,
    values: constraintInput.values,
    matchIfMissingProp: constraintInput.spec.matchIfMissingProp,
    inputRequired: constraintInput.spec.inputRequired,
  }
